// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_342rm_","extraLarge":"_19DTLO","icon":"_3hfJs6","both":"_3CRjmL","tooltip":"_1zjbBo"};